import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import noop from 'lodash/noop';
import includes from 'lodash/includes';

import './InteractiveMapMarker.scss';

const MARKER_SVG_PATH = 'M4.114 23.708A13.953 13.953 0 0 1 .2 14c0-7.732 6.268-14 14-14s14 6.268 14 14a13.95 13.95 0 0 1-3.676 9.456L14.962 34.3a1 1 0 0 1-1.5 0L4.114 23.708z';

export default class InteractiveMapMarker extends React.PureComponent {
    static propTypes = {
        numberOfPoints: PropTypes.number.isRequired,
        onMapMarkerClick: PropTypes.func,
        eventsId: PropTypes.arrayOf(
            PropTypes.string
        ),
        isMobileViewEventDefaultSelected: PropTypes.bool,
        mobileViewHoverTarget: PropTypes.string,
    }

    static defaultProps = {
        eventsId: [],
        onMapMarkerClick: noop,
    }

    _setRef = (node) => {
        this._ref = node;
    }

    _handleMapMarkerClickWithPosition = () => {
        this.props.onMapMarkerClick(this._ref);
    }

    render() {
        const {
            numberOfPoints,
            eventsId,
            hoverEventCardTarget,
            mobileViewHoverTarget,
        } = this.props;

        const shouldHover = !!eventsId.find((eventId) => includes([hoverEventCardTarget, mobileViewHoverTarget], eventId));
        const containerClassName = classNames(
            'interactive-map-marker__container',
            {
                'interactive-map-marker__container--hover': shouldHover,
            }
        );

        let textComponent = null;

        if (numberOfPoints && numberOfPoints > 1) {
            textComponent = (
                <text
                    className="interactive-map-marker__text eds-text-bs"
                    data-spec="interactive-map-marker-text"
                    x="14.25"
                    y="18"
                    fill="#FFF"
                    textAnchor="middle"
                >
                    {numberOfPoints}
                </text>
            );
        }

        return (
            <div className={containerClassName} data-spec="interactive-map-marker-container">
                <svg
                    className="interactive-map-marker"
                    ref={this._setRef}
                    xmlns="http://www.w3.org/2000/svg"
                    width="30" height="35"
                    onClick={this._handleMapMarkerClickWithPosition}
                    onKeyDown={this._handleMapMarkerClickWithPosition}
                    role="button"
                    tabIndex="-1"
                >
                    <path
                        fillRule="evenodd"
                        d={MARKER_SVG_PATH}
                    />
                    {textComponent}
                </svg>
            </div>
        );
    }
}
